{
  "app": {
    "tittel": "Noregspris for fjernvarme",
    "language": "Språk",
    "language_nb-NO": "Bokmål",
    "language_nn-NO": "Nynorsk"
  },
  "button": {
    "login": "Logg inn",
    "logout": "Logg ut",
    "next": "Neste",
    "back": "Tilbake",
    "back-to-frontpage": "Gå til framsida",
    "open": "Opne",
    "vis-forklaring": "Vis forklaring for {{felt}}"
  },
  "components": {
    "nyttige-lenker": "Nyttige lenkjer"
  },
  "enums": {
    "boligType": "{{context}}",
    "boligType_Boliglag": "Bustadlag",
    "boligType_Fritidsbolig": "Fritidsbustad",
    "boligType_Bolig": "Bustad",
    "boligType_Boligselskap": "Burettslag",
    "boligType_Andre": "Andre bygg med hushaldningsforbruk",
    "boligType_BoligselskapFritid": "Bustadselskap med fritidsbustader",
    "jaNei": "{{context}}",
    "jaNei_ja": "Ja",
    "jaNei_nei": "Nei"
  },
  "eksterneLenker": {
    "forskriftOmNorgespris": {
      "url": "https://lovdata.no/dokument/SF/forskrift/2025-09-08-1792",
      "label": "Forskrift om Noregspris"
    },
    "lovOmNorgespris": {
      "url": "https://lovdata.no/dokument/NL/lov/2025-06-20-44",
      "label": "Lov om Noregspris og straumstønad til hushaldningar"
    },
    "avtalevilkaar-og-avbestilling": {
      "url": "/vilkår",
      "label": "Avtalevilkår og avbestilling"
    },
    "merOmNorgespris": {
      "url": "https://www.nve.no/energi/energisystem/fjernvarme/norgespris-og-stroemstoette-for-fjernvarme/",
      "label": "Les meir om Noregspris"
    },
    "enovaSvarer": {
      "label": "Treng du hjelp? Enova Svarar",
      "url": "https://www.enova.no/nb/om-oss/hvem-er-enova/kontakt-oss"
    },
    "nve": {
      "label": "www.nve.no",
      "url": "https://nve.no/"
    },
    "cookies": {
      "label": "Personvern og informasjonskapslar",
      "url": "https://www.enova.no/nb/om-oss/hvem-er-enova/prinsipper-etterlevelse/datahandtering"
    },
    "tilgjengelighetserklæring": {
      "label": "Tilgjengelegheitserklæring",
      "url": "https://uustatus.no/nn/erklaringer/publisert/afe7c36c-a37b-4093-be92-821468ae6c17"
    },
    "spmOgSvarNve": {
      "label": "Spørsmål og svar til Noregspris og straumstøtte for fjernvarme",
      "url": "https://www.nve.no/energi/energisystem/fjernvarme/norgespris-og-stroemstoette-for-fjernvarme/spoersmaal-og-svar-norgespris-og-stroemstoette-for-fjernvarme/"
    },
    "kundestotte": {
      "label": "Treng du hjelp eller har du spørsmål?",
      "url": "/kundestøtte"
    }
  },

  "feilmelding": {
    "overskrift": "Det oppstod ein feil",
    "overskrift_404": "Fann ikkje sida",
    "beskrivelse": "Prøv igjen seinare.",
    "beskrivelse_404": "Sida du prøvde å nå finst ikkje.\nKanskje har du skrive inn ein feil adresse, eller så er sida flytta.",
    "beskrivelse_10001": "Prøv igjen seinare.",
    "prøv-igjen": "Prøv å laste sida på nytt"
  },
  "pages": {
    "landing": {
      "ingress": "Noregspris er ei ordning som er innført for å gi hushaldningar og fritidsbustader føreseielege prisar på straum og fjernvarme.",
      "button-bestill": "Bestill Noregspris",
      "ikke-aapnet-enda": {
        "tittel": "Bestilling av Noregspris opnar 24. september",
        "beskrivelse": "Frå 24. september kan du bestille Noregspris for fjernvarme ved å logge inn på denne sida. Les om ordninga på NVE (Norges vassdrags- og energidirektorat) sine nettsider.",
        "url-tittel": "Noregspris og straumstønad for fjernvarme"
      },
      "paa-vegne-av": {
        "tittel": "Bestille for bustadselskap eller andre kundar med hushaldningsforbruk?",
        "beskrivelse": "For bustadselskap, studentsamskipnad, kommunale bustader eller kombinasjonsbygg med hushaldningsforbruk bak målepunktet må du ha tilgangspakka <Uthevd>Tilskudd, Støtte og Erstatning</Uthevd>. Denne tilgangspakka tek over for rollene <Uthevd>Energi, miljø og klima</Uthevd> og <Uthevd>Utfyllar/innsendar</Uthevd> i Altinn. Roller vil ikkje kunne tildelast etter 15.06.2026, men dei som har rollene vil behalde tilgangen sin via desse til 31.12.2026."
      },
      "mer-info": {
        "tittel": "Meir informasjon om Noregspris",
        "prisregulering": {
          "tittel": "Pris",
          "beskrivelse": "Prisen du betalar for fjernvarme består av fleire delar. Vel du Noregspris for fjernvarme, vil den delen av fjernvarmeprisen som varierer med straumprisen vere 50 øre/kWh inkludert mva. i heile prisperioden. I tillegg skal du betale dei øvrige delane av fjernvarmeprisen som går fram av fjernvarmerekninga, til dømes avgifter, påslag og administrasjonskostnader.\n\nPrisen på 50 øre/kWh inkludert mva. blir kalla referansepris. Han vil frå og med 2027 bli vedteken kvart år og kan såleis endre seg for seinare prisperiodar."
        },
        "forbrukstak": {
          "tittel": "Forbrukstak",
          "beskrivelse": "For hushaldningsforbruk er forbrukstaket 4 500 kWh per månad per energimålar. Dette gjeld både straumstønad og Noregspris.\n\nFor fritidsbustader er forbrukstaket 1 000 kWh per månad per fritidsbustad. Dette gjeld for Noregspris.\n\nFor burettslag med fellesmålt fjernvarme er forbrukstaket 4 500 kWh per månad per bueining, og 1 000 kWh per månad per bueining for fritidsbustader.\n\nFor fjernvarmekundar som bur fast i fritidsbustad, er forbrukstaket 4 500 kWh per månad per energimålar.\n\nFor forbruk utover forbrukstaket får kunden ikkje beregna prissikringsbeløp for."
        },
        "norgespris": {
          "tittel": "Noregspris og straumstønad",
          "beskrivelse": "Noregspris er ei eiga avtale du inngår med fjernvarmeleverandøren din, i tillegg til avtalen partane har om fjernvarmeleveransen. Noregspris sikrar at du betaler 50 øre/kWh inkludert mva. for den delen av fjernvarmeprisen som varierer med straumprisen. Det inneber at når spotprisen på straum er høgare enn 50 øre/kWh, betalar staten mellomlegget mellom 50 øre/kWh (Noregspris) og spotprisen. Er spotprisen lågare enn 50 øre/kWh, betaler du framleis 50 øre/kWh.\n\nI perioden du er bunden til Noregspris, kan du ikkje få straumstønad.\n\nVel du ikkje Noregspris, vil du få straumstønad dersom du har rett til det. Straumstønad på fjernvarme gir støtte på 90 % av forbruket når gjennomsnittleg spotpris på straum er over 93,75 øre/kWh inkludert mva. Fritidsbustader har ikkje rett på straumstønad.\n\nDet du som kunde vel å gjere når det gjeld Noregspris eller straumstønad for fjernvarme, påverkar ikkje valet du kan gjere for Noregspris eller straumstønad for straum. Det betyr at fjernvarmekundar til dømes kan velje Noregspris både for fjernvarme og for straum, eller Noregspris for fjernvarme og straumstønad for straum. Val på straumsida må gjerast gjennom dei kanalane nettselskapet eller straumselskapet ditt informerer om."
        },
        "avtaleperiode": {
          "tittel": "Avtaleperiode og avbestilling",
          "beskrivelse": "Den første perioden med Noregspris gjeld frå 1. oktober 2025 til 31. desember 2026. Dette blir omtala som ei prisperiode.\n\nDu kan bestille Noregspris når som helst i løpet av prisperioden. Ved bestilling blir du bunden frå den 1. i påfølgjande månad og ut året. Unntaket er 1. til 15. oktober, då bestillinga gjeld frå 1. oktober 2025.\n\nDu har 14 dagars avbestillingsrett frå dagen du bestiller Noregspris. Etter desse 14 dagane er avtalen bindande fram til utgangen av prisperioden. For den første prisperioden tyder dette fram til 31. desember 2026. Det er ikkje mogleg å seie opp avtalen om Noregspris eller byte tilbake til den vanlege straumstønadsordninga før den aktuelle prisperioden er over.\n\nDersom du sel bustaden din, vil avtalen om Noregspris følgje bustaden. Dei nye eigarane av bustaden vil vere bundne til prisperioden er over."
        },
        "gjelder": {
          "tittel": "Kven gjeld Noregspris for?",
          "beskrivelse": "Noregspris gjeld for fylgjande kundekategoriar:\n• Privatpersonar med hushaldningsforbruk\n• Eigarar av fritidsbustader\n• Bustadselskap\n• Kommunale bustader og studentsamskipnader\n• Kombinasjonsbygg med hushaldningsforbruk bak målaren\n\nSjå under for å sjå kva selskap som er omfatta. Eit fjernvarmeselskap kan ha nærvarmeanlegg som ikkje er omfatta av ordninga."
        },
        "underlangt": {
          "tittel": "Kven er omfatta av ordninga?",
          "beskrivelse": "Alle fjernvarmeselskap med konsesjon etter energielova skal tilby Noregspris. Nokre fjernvarmeselskap brukar eiga bestillingsløysing. Du vil få informasjon frå fjernvarmeselskapet ditt dersom dette gjeld deg.\n\nNærvarmeselskap blir ikkje automatisk omfatta av kravet om å tilby Noregspris. Dei nærvarmeselskapa som registrerer seg hjå NVE kan likevel tilby Noregspris.\n\nI bestillingsløysinga vil du finne alle selskap som tilbyr Noregspris. Dersom du ikkje finn selskapet ditt, er dei ikkje omfatta av ordninga."
        }
      },
      "hjelpetekst-bilde": "Bilete som symboliserer eit nabolag med fjernvarme."
    },
    "velg-selskap": {
      "tittel": "Vel selskap",
      "beskrivelse": "Om du ønskjer å administrere avtalar for eit selskap, må du finne og velje selskapet i lista under. Vi vil då sjekke at du har rett tilgangspakke i Altinn. For å kunne administrere bestillingar og rapportere målerdata på vegner av eit fjernvarme-/nærvarmeselskap, må ein ha tilgangspakka <Uthevd>Tilskudd, Støtte og Erstatning</Uthevd>. Denne erstattar rollene <Uthevd>Energi, miljø og klima</Uthevd> og <Uthevd>Utfyllar/innsendar</Uthevd> i Altinn. Tilgangen du tidlegare fekk via desse rollene vil halde fram å fungere til 31.12.2026, men dei vil ikkje kunne tildelast etter 15.06.2026.",
      "form": {
        "label": "Vel selskap",
        "velg": "Logg inn",
        "autentiserer": "Sjekkar at du har rette tilgangar til selskapet...",
        "autentiser-mislyktes": "Innlogging med organisasjonsnummer {{orgnr}} mislykkast. Sjekk at du har rett tilgangspakke i Altinn.",
        "feil": {
          "pakrevd": "Du må velje eit selskap for å halde fram.",
          "ingen-tilganger": "Ingen tilgangar funne for denne brukaren.",
          "laste-feil": "Det oppstod ein feil ved lasting av selskap. Ver venleg og prøv igjen seinare."
        }
      }
    },
    "informasjon-om-norgespris": {
      "tittel": "Noregspris",
      "liste": {
        "tittel": "Oversikt over dei viktigaste delane av Noregspris.",
        "punkt-0": "Noregspris er ei eiga avtale du inngår med fjernvarmeleverandøren din. Ho gjeld i tillegg til avtalen om fjernvarmeleveransen du allereie har.",
        "punkt-1": "Dersom spotprisen på straum er over 50 øre inkl. mva., får du eit fradrag på fjernvarmerekninga di. Dersom spotprisen er lågare, får du eit tillegg. Fjernvarmerekninga di vil òg inkludere eventuelle påslag, avgifter og administrasjonskostnader.",
        "punkt-2": "Du er bunden frå første dag i påfølgjande månad etter at du har bestilt Noregspris, og fram til og med 31.12.2026.",
        "punkt-3": "Du kan avbestille Noregspris innan 14 dagar frå bestillingsdatoen. Etter dette er avtalen bindande fram til og med 31.12.2026.",
        "punkt-4": "Noregspris blir knytt til energimålaren din. Dersom du sel bustaden, vil dei nye eigarane få Noregspris ut avtaleperioden.",
        "punkt-5": "Noregspris gjeld opptil 4 500 kWh per månad per energimålar. Unntak: For bustadselskap gjeld forbrukstaket på 4 500 kWh per månad for kvar bueining. For fritidsbustader er forbrukstaket 1 000 kWh per månad.",
        "punkt-6": "Vel du Noregspris, vil du ikkje få straumstønad i same periode."
      }
    },
    "finn-leverandoer": {
      "tittel": "Finn leverandør",
      "beskrivelse": "For å kunne bestille Noregspris treng vi å vite kva fjernvarmeleverandør du har avtale med.",
      "velg-leverandoer-label": "Vel eller søk på leverandør",
      "laster": "Hentar leverandørar...",
      "ingen-treff": "Ingen treff",
      "singular": "%d leverandør",
      "plural": "%d leverandørar",
      "norgespris": {
        "tittel": "Noregspris hos {{navn}}"
      },
      "feil": {
        "leverandoerer": "Klarte ikkje hente leverandørar. Prøv igjen seinare."
      },
      "form": {
        "leverandoer": {
          "paaakrevd": "Du må velje ein leverandør for å fortsette.",
          "kan-ikke-bestilles-her": "Du kan ikkje bestille Noregspris for denne leverandøren her."
        }
      }
    },
    "aktoer": {
      "tittel": "Kven bestiller du på vegner av?",
      "beskrivelse": "Som privatperson bestiller du berre for deg sjølv.\n\nDu kan bestille på vegner av bustadselskap, studentsamskipnad, kommunale bustader eller kombinasjonsbygg med hushaldningsforbruk bak målepunktet dersom du har riktig tilgangspakke i Altinn.",
      "hvordan-tildele": "Korleis tildele tilgangspakke i Altinn?",
      "finner-ikke-selskap": "Dersom du ikkje finn selskapet ditt, må du først <Link>logge inn med selskapet her</Link>",
      "altinnlenke": {
        "tittel": "Korleis tildele tilgangspakke i Altinn",
        "url": "https://info.altinn.no/hjelp/ny-tilgangsstyring/tilgangspakker/via-menypunktet-fullmakter/"
      },
      "laster": "Hentar aktørar...",
      "ingen-treff": "Ingen treff",
      "singular": "%d aktør",
      "plural": "%d aktørar",
      "feil": {
        "hent": "Klarte ikkje hente aktørar. Prøv igjen seinare."
      },
      "form": {
        "felt": "{{context}}",
        "felt_aktoer": "Vel aktør",
        "aktoer": {
          "paaakrevd": "Du må velje ein aktør for å fortsette.",
          "orgnr-ugyldig": "Organisasjonsnummeret er ugyldig."
        },
        "innsender": "Innsendar"
      }
    },
    "periode": {
      "tittel": "Vel avtaleperiode",
      "beskrivelse": "Ved bestilling av Noregspris vil du verte bunden av avtalen frå den 1. i påfølgjande månad. Det er gjort eit unntak for perioden 1. til 15. oktober 2025, der du kan velje om avtalen skal gjelde frå 1. oktober 2025 eller 1. november 2025.\n\nNår du bestiller blir du bunden fram til utgangen av 2026, med mindre du nyttar deg av avbestillingsretten innan fristen.",
      "velg-periode-label": "Vel avtaleperiode",
      "feil": {
        "hent": "Klarte ikkje hente avtaleperiodar. Prøv igjen seinare."
      },
      "form": {
        "paaakrevd": "Du må velje ein periode for å fortsette.",
        "default-option": "Vel ein periode"
      }
    },
    "bestiller": {
      "felles": {
        "kundenummer": "Kundenummer",
        "målerId": "Målerpunkt-ID",
        "adresse": "Adresse",
        "postnummer": "Postnummer",
        "poststed": "Poststad"
      },
      "privat": {
        "tittel": "Informasjon om bustaden",
        "beskrivelse": "For å registrere bustaden din for Noregspris, treng vi informasjon du har registrert hos fjernvarmeleverandøren.",
        "form": {
          "felt": "{{context}}",
          "felt_boligType": "Type bustad",
          "felt_kundenummer": "Kundenummer",
          "felt_målerId": "Målerpunkt-ID",
          "felt_adresse": "Adresse",
          "felt_postnummer": "Postnummer",
          "felt_poststed": "Stad",
          "felt_vilkårAkseptert": "Stad",
          "hjelpetekst": "{{context}}",
          "hjelpetekst_kundenummer": "Kundenummeret finn du på fakturaen frå fjernvarmeleverandøren din.",
          "hjelpetekst_målerId": "Målepunkt-ID finn du vanlegvis på fjernvarmefakturaen din. Dersom du ikkje finn målepunkt-ID på fakturaen din, kan du fylle inn målernummer. Har fakturaen din ingen av delane, lar du feltet stå tomt.",
          "feil": {
            "boligType": {
              "påkrevd": "Du må velje ein bustadtype."
            },
            "målerId": {
              "påkrevd": "Målerpunkt-ID kan ikkje vere tom."
            },
            "kundenummer": {
              "påkrevd": "Kundenummer kan ikkje vere tom."
            },
            "adresse": {
              "påkrevd": "Adresse kan ikkje vere tom."
            },
            "postnummer": {
              "ugyldig": "Postnummer må vere 4 siffer."
            },
            "poststed": {
              "påkrevd": "Stad kan ikkje vere tom."
            },
            "vilkårAkseptert": {
              "påkrevd": "Du må godta vilkåra for å fortsette."
            }
          }
        }
      },
      "selskap": {
        "tittel": "Informasjon om bestillaren",
        "beskrivelse": "For å bestille Norgespris for burettslag eller andre bygg med hushaldsforbruk, treng vi informasjon de har registrert hjå fjernvarmeleverandøren.",
        "form": {
          "felt": "{{context}}",
          "felt_kundenummer": "Kundenummer",
          "felt_målerId": "Målerpunkt-ID",
          "felt_antallBoenheter": "Tal på bueiningar",
          "felt_næringsdrivende": "Er det næringsareal i burettslaget?",
          "felt_næringsarealProsent": "Del næringsareal i prosent",
          "felt_boligType": "Type organisasjon",
          "hjelpetekst": "{{context}}",
          "hjelpetekst_kundenummer": "Kundenummeret finn du på fakturaen frå fjernvarmeleverandøren din.",
          "hjelpetekst_målerId": "Målepunkt-ID finn du vanlegvis på fjernvarmefakturaen din. Dersom du ikkje finn målepunkt-ID på fakturaen din, kan du fylle inn målernummer. Har fakturaen din ingen av delane, lar du feltet stå tomt.",
          "hjelpetekst_næringsarealProsent": "Oppgi andel næringsareal i prosent av totalt oppvarma areal.\nOppvarma næringsareal (kvm) / totalt oppvarma areal i bygget (kvm) * 100 = andel næringsareal i prosent.",
          "boligType": {
            "tittel_Boligselskap": "Bustadselskap",
            "beskrivelse_Boligselskap": "Til dømes burettslag eller sameige som i tillegg kan ha tilknytt næringsareal.",
            "tittel_BoligselskapFritid": "Bustadselskap med fritidsbustader",
            "beskrivelse_BoligselskapFritid": "For bustadselskap som har fritidsbustader knytte til fjernvarme.",
            "tittel_Andre": "Andre bygg med hushaldningsforbruk",
            "beskrivelse_Andre": "Til dømes kjøpesenter eller kontorbygg som har tilknytte bustader."
          },
          "feil": {
            "målerId": {
              "påkrevd": "Målerpunkt-ID kan ikkje vere tom."
            },
            "kundenummer": {
              "påkrevd": "Kundenummer kan ikkje vere tom."
            },
            "antallBoenheter": {
              "positiv": "Tal på bueiningar må minst vere 1."
            },
            "næringsdrivende": {
              "påkrevd": "Du må velje om det er næringsareal i burettslaget."
            },
            "næringsarealProsent": {
              "paakrevd": "Næringsareal i prosent må fyllast ut.",
              "minMax": "Næringsareal i prosent må vere eit tal frå 1 til og med 100.",
              "maks-to-desimaler": "Berre tal mellom 1 og 100 er gyldige. Rund av til nærmaste to desimalar."
            },
            "boligType": {
              "påkrevd": "Du må velje ein type organisasjon."
            }
          }
        }
      },
      "felt-paakrevd": "Alle felt er påkravde."
    },
    "oppsummering": {
      "tittel": "Oppsummering",
      "beskrivelse": "Kontroller opplysningane og stadfest vilkåra for Noregspris for å fullføre bestillinga.",
      "felt": {
        "leverandør": {
          "tittel": "Leverandør",
          "navn": "Namn"
        },
        "aktør": {
          "tittel": "Bestillar",
          "navn": "Namn",
          "innsender": "Innsendar"
        },
        "avtaleperiode": {
          "tittel": "Avtaleperiode",
          "dato": "Dato"
        },
        "privat": {
          "tittel": "Informasjon om bustaden",
          "boligType": "Type bustad",
          "kundenummer": "Kundenummer",
          "målerId": "Målerpunkt-ID",
          "adresse": "Adresse"
        },
        "selskap": {
          "tittel": "Informasjon om bestillaren",
          "kundenummer": "Kundenummer",
          "målerId": "Målerpunkt-ID",
          "antallBoenheter": "Tal på bueiningar",
          "næringsdrivende": "Har næringsareal",
          "næringsarealProsent": "Del næringsareal i prosent",
          "boligType": "Type organisasjon",
          "ja": "Ja",
          "nei": "Nei"
        },
        "vilkårAkseptert": {
          "tittel": "Aksepter vilkåra",
          "checkbox-label": "Eg har lese og aksepterer vilkåra for Noregspris.",
          "les-vilkår": "Les vilkåra for Noregspris",
          "vilkår-må-aksepteres": "Du må godta vilkåra for å gjennomføre bestillinga."
        }
      },
      "laster": "Hentar...",
      "endre": "Endre",
      "gå-til-endre": "Gå til {{navn}}-sida for å endre opplysningane under",
      "ikke-utfylt": "Ikkje utfylt",
      "send-inn": "Send inn bestilling",
      "toast": {
        "suksess": "Du er no registrert for Noregspris for fjernvarme!",
        "feil": "Det oppstod ein feil ved innsending av bestillinga. Sjekk om alle felta er riktig utfylte, og prøv igjen.",
        "feil_409": "Bestillinga eksisterer allereie frå før. Vennlegst sjekk opplysningane og prøv igjen."
      },
      "dialog": {
        "oppretter-bestilling": "Opprettar bestilling..."
      },
      "personopplysninger": {
        "tittel": "Behandling av personopplysningar",
        "beskrivelse": "Energidepartementet har gitt Enova ansvaret for å utbetale og krevje inn støtte- og prissikringsbeløp knytt til fjernvarme. NVE skal føre tilsyn og kontroll med ordninga.\n\nDette inneber at Enova og NVE må samle inn og handsame personopplysningar som er naudsynlege for å ivareta sine lovfesta plikter. Plikta følgjer av ",
        "beskrivelse-lenke": "Forskrift om Noregspris og straumstønad til hushaldningar som brukar fjernvarme § 31."
      },
      "bestillingsdato": "Bestillingsdato"
    },
    "bekreftelse": {
      "feil": {
        "hent": "Klarte ikkje hente bestillinga. Prøv igjen seinare."
      },
      "header": {
        "tittel": "Bestillingsstadfesting",
        "beskrivelse": "Takk! Vi har motteke bestillinga di på Noregspris."
      },
      "avtale": {
        "selskap": {
          "leverandør": {
            "tittel": "Leverandør",
            "navn": "Namn"
          },
          "aktør": {
            "tittel": "Bestillar",
            "navn": "Namn",
            "organisasjonsnummer": "Organisasjonsnummer",
            "innsender": "Innsendar"
          },
          "avtaleperiode": {
            "tittel": "Avtaleperiode",
            "dato": "Dato"
          },
          "informasjon-om-boligselskap": {
            "tittel": "Informasjon om bestillaren",
            "type-bolig": "Type bustad",
            "type-bolig-boligselskap": "Burettslag",
            "type-organisasjon": "Type organisasjon",
            "kundenummer": "Kundenummer",
            "måler-id": "Målerpunkt-ID",
            "antall-boenheter": "Tal på bueiningar",
            "næringsareal": "Næringsareal",
            "andel-næringsareal": "Del næringsareal",
            "næringsdrivende": "Har næringsareal"
          }
        },
        "privat": {
          "leverandør": {
            "tittel": "Leverandør",
            "navn": "Namn"
          },
          "aktør": {
            "tittel": "Bestillar",
            "innsender": "Innsendar"
          },
          "avtaleperiode": {
            "tittel": "Avtaleperiode",
            "dato": "Dato"
          },
          "informasjon-om-bolig": {
            "tittel": "Informasjon om bustad",
            "type-bolig": "Type bustad",
            "kundenummer": "Kundenummer",
            "måler-id": "Målerpunkt-ID",
            "adresse": "Adresse"
          }
        }
      },
      "informasjon": {
        "pris-tittel": "Pris",
        "bindingstid-avbestill-tittel": "Bindingstid og avbestilling",
        "avbestill-tittel": "Avbestilling",
        "avbestill-beskrivelse": "Du har 14 dagars angrerett frå du bestilte Noregspris. Etter desse 14 dagane er avtalen bindande fram til 31. desember 2026. Det er ikkje mogleg å seie opp avtalen eller byte tilbake til den vanlege ordninga for straumstønad før bindingstida er ute. Dersom du sel bustaden, følgjer avtalen om Noregspris bustaden og vert overført til den nye eigaren.",
        "kontakt": {
          "spm-om-norgespris-tittel": "Spørsmål om Noregspris?",
          "faa-hjelp": "Ta kontakt med kundestøtte."
        }
      },
      "actions": {
        "knapp-navigasjon": "Gå til framsida"
      },
      "tidspunkt": {
        "avbestilt": "Avtale avbestilt",
        "endret": "Avtale sist endra",
        "opprettet": "Avtale oppretta"
      },
      "ikke-aktiv": "Avtalen er ikkje lenger aktiv.\n\nAvtalen gjaldt opphavleg for perioden: {{periode}}"
    },
    "endre": {
      "tittel": "Endre bestilling",
      "beskrivesle": "Du kan rette på bestillinga fram til avbestillingsfristen den {{context}}.",
      "form": {
        "feil": {
          "feil-lasting": "Det har oppstått ein feil, prøv igjen seinare",
          "feil-posting-tittel": "Endring mislykkast",
          "feil-posting-beskrivelse": "Det oppstod ein feil ved endring av bestillingen. Sjå om alle felta er riktig utfylte, og prøv igjen."
        },
        "suksess": {
          "suksess-tittel": "Endringane dine er lagra."
        },
        "leverandør": {
          "tittel": "Leverandør",
          "navn": "Namn"
        },
        "aktør": {
          "tittel": "Bestillar",
          "navn": "Namn",
          "organisasjonsnummer": "Organisasjonsnummer",
          "innsender": "Innsendar"
        },
        "avtaleperiode": {
          "tittel": "Avtaleperiode",
          "dato": "Dato"
        }
      },
      "knapper": {
        "lagre": "Lagre endringar",
        "avbryt": "Avbryt"
      }
    },
    "avtaler": {
      "statuser": {
        "avtaleStatus": "{{context}}",
        "avtaleStatus_Aktiv": "Aktiv",
        "avtaleStatus_Avbestilt": "Avbestilt",
        "avtaleStatus_Utgått": "Utgått",
        "avtaleStatus_Ugyldig": "Avtale kansellert",
        "ugyldigAvtaleÅrsak": "{{context}}",
        "ugyldigAvtaleÅrsak_Annet": "Annet",
        "ugyldigAvtaleÅrsak_IngenKundeForhold": "Ingen kundeforhold"
      },
      "avbestilling": {
        "tittel": "Avbestilling av Noregspris",
        "beskrivelse": "Ved å avbestille Noregspris innan avbestillingsfristen på 14 dagar, vil du gå tilbake til ordninga med straumstønad, med unntak av kundar med fritidsbustader.",
        "feil-lasting": "Det har oppstått ein feil, prøv igjen seinare",
        "leverandør-tittel": "Leverandør",
        "leverandør-navn": "Namn",
        "bestiller-tittel": "Bestillar",
        "avtaleperiode-tittel": "Avtaleperiode",
        "avtaleperiode-dato": "Dato",
        "innsender": "Innsendar",
        "informasjon-privat-tittel": "Informasjon om bustad",
        "informasjon-selskap-tittel": "Informasjon om bestillaren",
        "bekreft-avbestilling-tittel": "Stadfest avbestilling",
        "bekreft-avbestilling-checkbox": "Eg bekreftar at eg ynskjer å avbestille Noregspris",
        "feil-bekreft-avbestilling-tittel": "For å avbestille må du sørgje for følgjande",
        "feil-bekreft-avbestilling": "Stadfest avbestilling",
        "knapp-avbryt": "Avbryt",
        "knapp-avbestill": "Avbestill Noregspris",
        "alert-vellykket-tittel": "Avbestilling vellykka!",
        "alert-vellykket-beskrivelse": "Vi har motteke avbestillinga di",
        "alert-feilet-tittel": "Avbestilling feila",
        "alert-feilet-beskrivelse": "Det oppstod ein feil under avbestillinga. Prøv igjen.",
        "alert-utløpt-tittel": "Avtale utløpt",
        "alert-utløpt-beskrivelse": "Avtalen utløp den",
        "alert-frist-utløpt-tittel": "Avbestillingsfristen er utløpt.",
        "alert-first-utløpt-beskrivelse": "Du er bunden til avtalen om Noregspris fram til"
      },
      "avtaler": {
        "tittel": "Avtalar",
        "beskrivelse": "Her finn du dine avtalar om Noregspris.",
        "ingen-aktive-avtaler": "Ingen aktive bestillingar.",
        "bestill-norgespris": "Bestill Noregspris",
        "ingen-bestillinger": "Du har ingen bestillingar. Dersom avbestillingsperioden er over, vil bestillinga liggje under avtalar.",
        "legg-til-ny-bestillinger": "Legg til ny bestilling",
        "detaljer": {
          "avbestilt": "Avbestilt",
          "avtaleperiode": "Avtaleperiode",
          "typeBolig": "Type bustad",
          "kundeNummer": "Kundenummer",
          "målerId": "Målerpunkt-ID",
          "adresse": "Adresse",
          "organisasjonsNummer": "Organisasjonsnummer",
          "avbestilling": "Kan avbestillast fram til",
          "bestiller-epost": "E-post",
          "bestiller-navn": "Namn",
          "antallBoenheter": "Tal på bueiningar",
          "næringsdrivende": "Næringsareal",
          "næringsareal": "Del næringsareal",
          "organisasjonType": "Type organisasjon"
        },
        "valg": {
          "tittel": "Val",
          "endre": "Endre",
          "vis-kvittering": "Vis ordrestadfesting",
          "avbestill": "Avbestill"
        },
        "ugyldig-avtale": {
          "beskrivelse": "Avtalen er kansellert av leverandøren.",
          "årsak": "Årsak: {{context}}",
          "melding-fra-leverandør": "Melding frå {{context}}:",
          "default-melding": "Ta kontakt med {{context}} for meir informasjon."
        }
      },
      "header": {
        "tittel": "Hei, {{navn}}",
        "beskrivelse-med-selskap": "Du er for augeblikket logga inn med <Uthevd>{{selskapsNavn}}</Uthevd>, og vil kunne administrere avtalane til selskapet i tillegg til dine eigne. \n Om du ønskjer å byte selskap, kan du gjere det ved å klikke på knappen til høgre.",
        "beskrivelse-uten-selskap": "Om du ønskjer å administrere avtalar for eit selskap, kan du gjere det ved å klikke på knappen til høgre.",
        "bytt-selskap-knapp": "Vel selskap"
      }
    },
    "kundestotte": {
      "spoersmaal-om-fjernvarme": {
        "tittel": "Spørsmål om fjernvarme",
        "beskrivelse": "Har du spørsmål om avtale, faktura eller generelt om fjernvarme, ta kontakt med fjernvarmeleverandøren din."
      },
      "spoersmaal-om-loesning": {
        "lenke-kontakt-oss": "Enova - Kontakt oss",
        "beskrivelse": "Har du tekniske spørsmål om bestillingsløysinga for Noregspris, kan du ta kontakt med Enova Svarar.",
        "tittel": "Spørsmål til bestillingsløysinga"
      },
      "spoersmaal-om-regelverk": {
        "lenke-mer-om-regelverket": "NVE - Spørsmål og svar til Noregspris og straumstønad for fjernvarme",
        "beskrivelse": "Har du spørsmål eller treng meir informasjon om Noregspris og straumstønad for fjernvarme, kan du finne svar på NVE sine nettsider.",
        "tittel": "Spørsmål om regelverket for Noregspris",
        "lenke-om-norgespris": "NVE - Noregspris og straumstønad for fjernvarme"
      },
      "fjernvarmeleverandoer": {
        "tittel": "Fjernvarmeleverandør",
        "beskrivelse": "Som leverandør av fjernvarme kan du finne meir informasjon og avtalar for kundane dine i selskapsportalen.",
        "lenke-kontakt-oss": "Selskapsportalen for fjernvarmeleverandørar"
      },
      "tittel": "Kundestøtte"
    }
  },
  "skjema": {
    "navigering": {
      "kan-lagre": {
        "tittel": "Vil du lagre endringane?",
        "beskrivelse": "Du har gjort endringar som ikkje er lagra. Ønskjer du å lagre før du går vidare?",
        "lagre": "Ja, lagre",
        "ikke-lagre": "Nei, ikkje lagre"
      },
      "kan-ikke-lagre": {
        "tittel": "Ulagra endringar",
        "beskrivelse": "Skjemaet inneheld ugyldige data. Du må rette opp i feila før du kan lagre.",
        "videre": "Gå vidare utan å lagre",
        "avbryt": "Avbryt og rett opp feil"
      },
      "next-button-disabled": "Kan ikkje gå til neste steg før alle felta over er fylt ut korrekt."
    },
    "feil-oppsummering": "For å gå vidare må du rette opp følgjande feil",
    "stepper": "Steg {{steg}} av {{total}}",
    "feil-ved-henting": "Det oppstod ein feil ved henting av skjema",
    "laster": "Hentar skjema..."
  },
  "password-protection": {
    "tittel": "Passordbeskyttelse",
    "beskrivelse": "Innlogging er berre open for personar som skal teste løysinga. Gå tilbake til framsida for å lese meir om når Noregspris for fjernvarme blir tilgjengeleg for alle.",
    "tilbake": "Tilbake til framsida",
    "passord": {
      "label": "Passord",
      "placeholder": "Skriv inn passord"
    },
    "feil": {
      "ugyldig-passord": "Ugyldig passord. Prøv igjen.",
      "passord-pakrevd": "Passord er påkravd for å fortsette."
    }
  },
  "toaster": {
    "lukk": "Lukk varsel"
  },
  "callback": {
    "logger-inn": "Loggar inn",
    "venter": "Ver venleg og vent medan vi fullfører innlogginga."
  }
}
